const BASE_URL: any = process.env.REACT_APP_BASE_URL;
const API_URL = `${BASE_URL}/api`;

export default API_URL;
export { BASE_URL };
